export default {
  unKnow: {
    code: 0,
    title: 'Unknow',
    sort: 100,
    video: ''
  },
  zip: {
    code: 5,
    title: 'ZIP',
    name: 'zip',
    sort: 1,
    isMulti: true,
    video: 'https://vimeo.com/387725028/'
  },
  city: {
    code: 4,
    title: 'City',
    name: 'city',
    sort: 6,
    isMulti: true,
    video: 'https://vimeo.com/390977369/'
  },
  state: {
    code: 2,
    title: 'State',
    name: 'state',
    sort: 7,
    isMulti: true,
    video: 'https://vimeo.com/390977352'
  },
  county: {
    code: 3,
    title: 'County',
    name: 'county',
    sort: 4,
    isMulti: true,
    video: 'https://vimeo.com/390977369/'
  },
  moreArea: {
    code: 23,
    name: 'moreArea',
    title: 'Multi Geo',
    sort: 20,
    video: ''
  },
  radius: {
    code: 16, // TODO@PONY need to fix code
    title: 'Radius',
    name: 'radius',
    sort: 2,
    video: 'https://vimeo.com/389566032/'
  },
  singleradius: {
    code: 7,
    title: 'Radius',
    name: 'singleradius'
  },
  polygon: {
    code: 13,
    title: 'Polygon',
    name: 'polygon',
    sort: 3,
    video: 'https://vimeo.com/390508169/'
  },
  totalUSA: {
    code: 20,
    title: 'Total USA',
    name: 'totalUSA',
    routeName: 'demo-demoDemographics',
    notGeo: true,
    sort: 9,
    video: ''
  },
  multiCount: {
    code: 24,
    name: 'multiCount',
    title: 'Multi Saved List Count',
    routeName: 'demo-multiCount',
    notGeo: true,
    isDirectCount: true,
    sort: 10,
    video: ''
  },
  congressionalDistrict: {
    code: 22,
    title: 'Congressional District',
    name: 'congressionalDistrict',
    sort: 11,
    video: 'https://vimeo.com/390977369'
  },
  metroArea: { // msa
    code: 10,
    title: 'Metro Area',
    name: 'metroArea',
    sort: 8,
    video: 'https://vimeo.com/390977369'
  },
  zipMap: { // UN Down
    code: 18,
    title: 'zip'
  },
  acxiomZipRadius: { // UNknow
    code: 17,
    title: 'radius',
    hideTwoDimension: true
  },
  acxiomMultiRadius: { // unknow ,just in InfoUSA_IDMS_Busines, Mobile_Consumer_Advertising
    code: 16,  // 14 there is no one use 14
    title: 'radius'
  },
  multiClosex: { // unKnow, just for InfoUSABusiness, InfoUSAConsumer
    code: 15,
    title: 'close record'
  },
  Closex: {
    code: 12,
    name: 'radius',
    title: 'Closest Prospects',
    hideBreakDownIfTwoDimension: true,
    video: ''
  },
  SCFCode: {
    code: 8,
    name: 'SCFCode',
    title: 'SCF Codes',
    sort: 12,
    video: 'https://vimeo.com/390977323/'
  }
}



// WEBPACK FOOTER //
// ./src/config/geoType.js